import AppRouter from "./appRouter";

export default AppRouter;